/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        "name": "文本",
        "type": "module-name"
    },
    {
        "key": "property_data",
        "name": "属性",
        "type": "custom",
        "content": [{
                "key": "content",
                "name": "内容",
                "type": "rich-text",
            },
            {
                "key": "margin_top",
                "name": "上边距",
                "type": "height",
            },
            {
                "key": "margin_right",
                "name": "右边距",
                "type": "height",
            },
            {
                "key": "margin_bottom",
                "name": "下边距",
                "type": "height",
            },
            {
                "key": "margin_left",
                "name": "左边距",
                "type": "height",
            },
        ],
    },
];

export default config;